<div class="account-bubble">
  <div
    class="circle"
    (click)="this.openAccountBubble()"
    (keydown.enter)="this.openAccountBubble()"
    (keydown.Space)="this.openAccountBubble()"
  >
    <span>{{this.initials}}</span>
  </div>
  <div
       class="dropdown {{isAccountBubbleOpen ? 'open' : 'close'}}"
       >
    <!-- <div 
            class="link" 
            id="first"
        >
            <span>Account</span>
        </div> -->
    <div
      class="link"
      id="last"
      (click)="logout()"
      (keydown.Space)="logout()"
      (keydown.enter)="logout()"
      tabindex="0"
    >
      <span [hidden]="this.selected" [innerHTML]="'Logout'"></span>
      <span [hidden]="!this.selected">
        <kendo-loader
          [type]="loader.type"
          [themeColor]="loader.themeColor"
          [size]="loader.size"
        >
        </kendo-loader>
      </span>
    </div>
  </div>
</div>
